export class Controller {

    /** @ngInject */
    constructor($state, ShareAnAdditionalEmailAccount, SharedEmailAccountModal) {
        this.$state = $state;
        this.ShareAnAdditionalEmailAccount = ShareAnAdditionalEmailAccount;
        this.SharedEmailAccountModal = SharedEmailAccountModal;
    }

    $onInit() {
        this.userDirectoriesHref = this.$state.href('company.user-directories');
    }

    showShareAnAdditionalEmailAccountModal() {
        this.ShareAnAdditionalEmailAccount();
    }

    showSharedEmailAccountModal(account) {
        this.SharedEmailAccountModal(account.username)
            .then(() => this.$state.reload(this.$state.current));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-accounts/shared-accounts.controller.js